import { combineReducers } from "@reduxjs/toolkit";

import signInReducer from "../slices/signIn.slice";
import signUpReducer from "../slices/signUp.slice";
import employeeDashboardReducer from "../slices/Employee/employeeDashboard.slice";
import goalsReducer from "../slices/Employee/goals.slice";
import crrSurveyReducer from "../slices/Employee/survey-CRR.slice";
import surveyListReducer from "../slices/Admin/surveyList.slice";
import userManagementReducer from "../slices/Admin/userManagement.slice";
import editEmployeeProfileReducer from "../slices/Employee/editEmployeeProfile.slice";
import organisationProfileReducer from "../slices/Admin/organisationProfile.slice";
import performanceSummaryReducer from "../slices/Employee/employeePerformanceSummarySlice";
import notificationReducer from "../slices/Employee/notification.slice";
import superAdminOrganizationListReducer from "../slices/SuperAdmin/OrganisationList.slice";
import organizationSurveyTabReducer from "../slices/SuperAdmin/OrganizationSurveyTab.slice";
import organizationProfileTabReducer from "../slices/SuperAdmin/OrganizationProfileTab.slice";
import preAssessmentReducer from "../slices/Admin/preAssessments.slice";
import controlLibraryReducer from "../slices/Admin/contolLibrary.slice";
import stateAdminManagementReducer from "../slices/StateDOTAdmin/userManagement.slice";
import StateAdminDashboardReducer from "../slices/StateDOTAdmin/stateAdminDashboard.slice";
import sidebarReducer from "../slices/sidebar.slice";
import csfSurveyReducer from "../slices/Admin/survey-CSF.slice";

const combinedReducer = combineReducers({
  signIn: signInReducer,
  signUp: signUpReducer,
  employeeDashboard: employeeDashboardReducer,
  goals: goalsReducer,
  CRRsurvey: crrSurveyReducer,
  CSFSurvey: csfSurveyReducer,
  surveyList: surveyListReducer,
  userManagement: userManagementReducer,
  editEmployeeProfile: editEmployeeProfileReducer,
  organisationProfile: organisationProfileReducer,
  performanceSummary: performanceSummaryReducer,
  notification: notificationReducer,
  superAdminOrganizations: superAdminOrganizationListReducer,
  organizationSurveyTab: organizationSurveyTabReducer,
  organizationProfileTab: organizationProfileTabReducer,
  preAssessment: preAssessmentReducer,
  controlLibrary: controlLibraryReducer,
  stateAdminManagement: stateAdminManagementReducer,
  stateAdminDashboard: StateAdminDashboardReducer,
  sidebar: sidebarReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "signIn/logout") {
    state = undefined;
  }
  return combinedReducer(state, action);
};

export default rootReducer;
